<script setup lang="ts">
definePageMeta({
  title: "トップ",
})
</script>

<style>
#top-image {
  --max_calc_65vh_64px: max(calc(65vh - 64px));
  --max_calc_80vh_64px: max(calc(80vh - 64px));
}
</style>

<template>
  <div style="
    display: flex;
    justify-content: center;
    margin-top: -64px;
    padding-top: 64px;
    overflow: hidden;
    background-color: #FDEED2;
    margin-bottom: 32px;
  ">
    <picture>
      <source 
        media="(max-width:600px)"
        srcset="/img/poster_mobile.jpg 600w"
        sizes="100vw"
      >
      <img src="/img/poster_pc.jpg"  id="top-image" class="
          h-[calc(8670/6154*100vw)]
          md:h-(--max_calc_65vh_64px)
          lg:h-(--max_calc_80vh_64px)
        " style="
          max-width: none;
        ">
    </picture>
  </div>
    <div class="max-w-[900px] mx-auto p-2">
    <div class="p-2 border-2 border-primary rounded text-center text-primary bg-violet-100" >
      <p class="text-2xl font-bold mb-1">
        おしらせ
      </p>
      <p class="text-xl md:text-4xl font-bold mb-2">
        本年のコスモス祭は終了いたしました！<br/>
        ご来場ありがとうございました！
      </p>
    </div>
  </div>
  <div class="max-w-[900px] mx-auto p-2">
    <div class="grid w-full grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 min-h-[128px] mb-8">
      <NuxtLink class="btn btn-primary btn-outline rounded-none w-full h-full text-3xl shadow-md min-h-[72px]"
        to="/map">
        キャンパス<br class="hidden lg:inline" />マップ
      </NuxtLink>
      <NuxtLink class="btn btn-primary btn-outline rounded-none w-full h-full text-3xl shadow-md min-h-[72px]"
        to="/timetable">
        タイム<br class="hidden lg:inline" />テーブル
      </NuxtLink>
      <NuxtLink class="btn btn-primary btn-outline rounded-none w-full h-full text-3xl shadow-md min-h-[72px]"
        to="/event">
        企画<span class="inline lg:hidden">・</span><br class="hidden lg:inline" />イベント
      </NuxtLink>
      <NuxtLink class="btn btn-primary btn-outline rounded-none h-full text-3xl shadow-md min-h-[72px]" to="/booth">
        展示<span class="inline lg:hidden">・</span><br class="hidden lg:inline" />模擬店
      </NuxtLink>
    </div>

    <div class="w-full mb-8">
      <NuxtLink class="btn btn-primary btn-outline rounded-none w-full h-full text-4xl shadow-md min-h-[96px]"
        to="/best-booth-award">
        模擬店大賞
      </NuxtLink>
    </div>
    <div class="border-solid border-primary border-[1px] text-primary" style="
        width: 100%;
        margin-bottom: 16px;
        padding: 8px 0;
        border-radius: 4px;
      ">
      <div class="  
        grid
        grid-cols-[100%]
        md:grid-cols-[60%_40%]
        lg:grid-cols-[40%_30%_30%]
      " style="
        font-weight: bold;
        flex-flow: row;
        flex-wrap: wrap;
      ">
        <div class="
          pb-[16px]
          md:pb-[0px]
          border-b-[4px]
          md:border-b-[0px]
          md:border-r-[6px]
          border-primary
          border-solid
        " style="
          width: 100%;
          display: flex; 
          align-items: center; 
          flex-flow: column;
          letter-spacing: 0.2em;
        ">
          <div style="font-size: 2.5em; text-align: end;">
            11月8日(土)<br />
            9日(日)
          </div>
          <div style="font-size: 2em;">
            10:00 ～ 16:00
          </div>
        </div>
        <div class="
          pt-[8px]
          md:pt-[0px]
          lg:border-r-[6px]
          border-primary
          border-solid
        " style="
          width: 100%;
          text-align: center;
          font-size: 2.2em;
          letter-spacing: 0.1em;
          height: 100%;
        ">
          課外活動展<br />
          収穫祭<br />
          学部展
        </div>
        <div class="hidden lg:block" style="
          width: 100%;
          text-align: center;
          font-size: 1.4em;
          line-height: 1.2em;
          letter-spacing: 0.35em;
        ">
          文学部<br />
          農学部<br />
          工学部<br />
          経営学部<br />
          教育学部<br />
          芸術学部<br />
          <span style="letter-spacing: 0.1em;">リベラルアーツ学部</span><br />
          観光学部
        </div>
      </div>
    </div>
  </div>
</template>
